var setLocalStorageWithExpiry = function setLocalStorageWithExpiry(key, value) {
  var ttl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 86400000;
  var now = new Date(); // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire

  var item = {
    value: value,
    expiry: now.getTime() + ttl
  };
  localStorage.setItem(key, JSON.stringify(item));
};

var getLocalStorageWithExpiry = function getLocalStorageWithExpiry(key) {
  var itemStr = localStorage.getItem(key); // if the item doesn't exist, return null

  if (!itemStr) {
    return null;
  }

  var item = JSON.parse(itemStr);
  var now = new Date(); // compare the expiry time of the item with the current time

  if (Number.isNaN(item.expiry) || now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key);
    return null;
  }

  return item.value;
};

export { setLocalStorageWithExpiry, getLocalStorageWithExpiry };